import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { usersPageVariableDelete } from "../reducers/users-page-variable-actions";
import { usersPageCloseModal } from "../reducers/users-page-actions";
import { Confirmar } from "../../../../components";
import { useToggle } from "react-use";

const STR = {
  title: "Excluir Variável",
  subtitle: "Deseja realmente excluir a variável?",
};

function VariableDelete({ id }) {
  const [wait, setWait] = useToggle();
  const dispatch = useDispatch();
  const onConfirm = useCallback(() => {
    dispatch(usersPageVariableDelete(id, setWait));
  }, [dispatch, setWait, id]);
  //
  const onCancel = useCallback(() => {
    dispatch(usersPageCloseModal());
  }, [dispatch]);

  return (
    <Confirmar
      titulo={STR.title}
      subtitulo={STR.subtitle}
      fnCancelar={onCancel}
      fnConfirmar={onConfirm}
      aguardar={wait}
    />
  );
}

export default VariableDelete;
